'use strict';

var $ = require('jquery');
var _ = require('underscore');
var ToastView = require('../toast').default;
var Radio = require('backbone.radio');
var FooterView = require('../footer/footer').default;
var Marionette = require('backbone.marionette');
var CancelToastView = require('../cancel-toast').default;
var settings = require('../../utilities/settings').default;
var KEYCODES = require('../../utilities/keycodes').default;
var CancelRequestToastView = require('../cancel-request-toast').default;

export default Marionette.View.extend({

  className: 'l-main',
  template: require('./templates/main.hbs'),
  regions: {
    toast: '.l-main-toast',
    longToast: '.l-main-long-toast',
    cancelToast: '.l-main-cancel-toast',
    header: '.l-main-header',
    main: '#main',
    footer: '.l-main-footer',
    modal: '#modal .modal-body',
  },
  ui: {
    header: '.l-main-header',
    main: '#main',
    footer: '.l-main-footer',
    modal: '#modal',
    longToast: '.l-main-long-toast',
    cancelToast: '.l-main-cancel-toast',
  },
  events: {
    'click .modal-close': 'onClickModalClose',
    'keyup': 'onKeyUp',
  },

  initialize: function () {
    this.headerView = this.options.headerView;
    this.customModalClass = null;

    Radio.channel('steps').on('change:current', this.hideModal, this);
    this.listenTo(Radio.channel('toast'), 'show', this.showToast);
    this.listenTo(Radio.channel('toast'), 'hide', this.hideToast);
    this.listenTo(Radio.channel('long-toast'), 'show', this.showLongToast);
    this.listenTo(Radio.channel('long-toast'), 'hide', this.hideLongToast);
    this.listenTo(Radio.channel('cancel-toast'), 'show', this.showCancelToast);
    this.listenTo(Radio.channel('cancel-toast'), 'hide', this.hideCancelToast);
    this.listenTo(Radio.channel('waitlist_confirmation'), 'show', this.showCancelRequestToast);
    this.listenTo(Radio.channel('waitlist_confirmation'), 'hide', this.hideCancelRequestToast);
    this.listenTo(Radio.channel('modal'), 'show', this.showModal);
    this.listenTo(Radio.channel('modal'), 'hide', this.hideModal);
    this.listenTo(this.getRegion('main'), 'show', this.onShowMain);
    this.setUpResizing();
  },

  onRender: function () {
    if (this.headerView) {
      this.showChildView('header', this.headerView);
    }
    this.showChildView('footer', new FooterView());
    this.ui.modal.hide();
    this.ui.modal.css('visibility', 'visible');
  },

  onKeyUp: function (evt) {
    if (evt.keyCode === KEYCODES.ESCAPE) {
      Radio.channel('windows').trigger('close');
    } else if (evt.keyCode === KEYCODES.LEFT || evt.keyCode === KEYCODES.RIGHT || evt.keyCode === KEYCODES.UP || evt.keyCode === KEYCODES.DOWN) {
      Radio.channel('calendar').trigger('navigate', evt.keyCode);
    }
  },

  onShowMain: function () {
    this.updateMainHeight();
    this.setModalTop();
  },

  onClickModalClose: function (evt) {
    evt.preventDefault();
    this.hideModal();
  },

  updateMainHeight: function () {
    if (settings.inHiddenIFrame()) {
      setTimeout(this.updateMainHeight.bind(this), 1000);
    } else {
      var measurement = this.ui.header.outerHeight() + this.ui.footer.outerHeight();

      this.ui.main.height('calc(100% - ' + measurement + 'px)');
    }
  },

  setModalTop: function () {
    this.modalTop = this.ui.header.outerHeight() / 2;
  },

  updateModalHeight: function () {
    this.ui.modal.height('calc(100% - ' + (this.ui.header.outerHeight() + this.ui.footer.outerHeight() + this.modalTop) + 'px)');
  },

  showToast: function(options) {
    var toast = new ToastView(options);

    if (toast.isSkippable() && toast.userWantsToSkip()) {
      return;
    }

    this.getRegion('toast').show(toast);
    toast.show();
  },

  hideToast: function () {
    var toast = this.getRegion('toast').currentView;

    if (toast) {
      toast.hide();
    }
  },

  showLongToast: function(options) {
    options.className = 'coconut-modal-persistent';
    var toast = new ToastView(options);

    if (toast.isSkippable() && toast.userWantsToSkip()) {
      return;
    }

    this.getRegion('longToast').show(toast);
    toast.show();
  },

  hideLongToast: function () {
    var toast = this.getRegion('longToast').currentView;

    if (toast) {
      this.updateMainHeight();
    }
  },

  showCancelToast: function (options) {
    var toast = new CancelToastView(options);

    this.getRegion('cancelToast').show(toast);
    toast.show();
  },

  hideCancelToast: function () {
    var toast = this.getRegion('cancelToast').currentView;

    if (toast) {
      this.ui.cancelToast.hide();
      Radio.channel('cancel-toast').trigger('hidden');
    }
  },

  showCancelRequestToast: function (options) {
    var toast = new CancelRequestToastView(options);

    this.getRegion('cancelToast').show(toast);
    toast.show();
  },

  hideCancelRequestToast: function () {
    var toast = this.getRegion('cancelToast').currentView;

    if (toast) {
      this.ui.cancelToast.hide();
      Radio.channel('cancel-request-toast').trigger('hidden');
    }
  },

  showModal: function (view, customClass) {
    this.getRegion('modal').empty();
    this.getRegion('modal').show(view);

    this.ui.modal.css('top', '100vh');
    if (customClass) {
      this.ui.modal.addClass(customClass);
      this.customModalClass = customClass;
    }
    this.ui.modal.show();

    // make sure modal always opens at the top
    this.ui.modal.scrollTop(0);

    var self = this;
    this.ui.modal.animate({
      top: this.modalTop,
    }, {
      complete: function () {
        self.ui.modal.find(':input').first().focus();
      },
    });
  },

  hideModal: function () {
    if (!this.ui.modal.is(':visible')) {
      return;
    }

    var self = this;
    this.ui.modal.animate({
      top: '100vh',
    }, {
      complete: function () {
        if (self.customModalClass) {
          self.ui.modal.removeClass(self.customModalClass);
          self.customModalClass = null;
        }
        self.ui.modal.hide();
        Radio.channel('modal').trigger('hidden');
      },
    });
  },

  setUpResizing: function () {
    $(window).on('resize', _.debounce(
      this.updateHeightAsNecessary.bind(this), 150)
    );
  },

  updateHeightAsNecessary: function () {
    this.updateMainHeight();
  },

});
